import api from './api';

export interface CostHistoryRecord {
  id: number;
  tenant_id: number;
  product_id: number;
  user_id?: number;
  old_cost?: number;
  new_cost: number;
  sale_price_at_change?: number;
  list_price_at_change?: number;
  quantity_purchased?: number;
  supplier?: string;
  notes?: string;
  cost_change_percent?: number;
  created_at: string;
  product_name?: string;
  user_name?: string;
}

export interface CostStatistics {
  product_id: number;
  product_name: string;
  total_records: number;
  first_cost?: number;
  last_cost?: number;
  min_cost?: number;
  max_cost?: number;
  avg_cost?: number;
  total_change_percent?: number;
  first_record_date?: string;
  last_record_date?: string;
}

export interface TopCostIncrease {
  product_id: number;
  product_name: string;
  old_cost: number;
  new_cost: number;
  change_percent: number;
}

export interface CostHistoryFilters {
  product_id?: number;
  start_date?: string;
  end_date?: string;
  limit?: number;
  offset?: number;
}

export const costHistoryService = {
  // Obtener historial general con filtros
  async getCostHistory(filters?: CostHistoryFilters): Promise<CostHistoryRecord[]> {
    const response = await api.get<CostHistoryRecord[]>('/cost-history', {
      params: filters,
    });
    return response.data;
  },

  // Obtener historial de un producto específico
  async getProductCostHistory(productId: number, limit = 50): Promise<CostHistoryRecord[]> {
    const response = await api.get<CostHistoryRecord[]>(`/cost-history/product/${productId}`, {
      params: { limit },
    });
    return response.data;
  },

  // Obtener estadísticas de costos de un producto
  async getProductCostStatistics(productId: number): Promise<CostStatistics> {
    const response = await api.get<CostStatistics>(`/cost-history/product/${productId}/statistics`);
    return response.data;
  },

  // Obtener productos con mayor aumento de costo
  async getTopCostIncreases(days = 30, limit = 10): Promise<TopCostIncrease[]> {
    const response = await api.get<TopCostIncrease[]>('/cost-history/top-increases', {
      params: { days, limit },
    });
    return response.data;
  },
};
